import styled from 'styled-components';

export const FileWrapper = styled.button`
  outline: none;
  background: none;
  padding: 11px;
  display: flex;
  align-items: center;
  cursor: pointer;
  border-radius: 7px;
  border: 0.5px solid #c2c2c2;
  width: 170px;
  position: relative;
  background-color: #fff;
  ${({ isActive }) =>
    isActive &&
    `

background:#3D3BFF33;
  `}

  &:hover {
    border-color: ${({ theme }) => theme.colors.background.action};
  }
`;

export const DeleteButton = styled.button`
  display: flex;
  outline: none;
  border: none;
  background-color: transparent;
  position: absolute;
  bottom: 5px;
  right: 5px;
  cursor: pointer;
  padding: 0;
  width: 20px;
  height: 20px;
  padding: 4px;
  background: ${({ isActive }) => (isActive ? 'rgba(61, 59, 255, 0.2)' : '#EDF0F5')};
  align-items: center;
  justify-content: center;
  border-radius: 4px;

  svg {
    width: 18px;
    height: 18px;
    path {
      fill: ${({ isActive }) => (isActive ? '#fff' : '#2B313D')};
      &:last-child {
        stroke: ${({ isActive }) => (isActive ? '#fff' : '#2B313D')};
      }
    }
  }
`;

export const FileIcon = styled.div`
  display: flex;
  width: 17px;
  min-width: 17px;
  max-width: 17px;
`;

export const FileContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: flex-start;
  margin-left: 9px;
  width: calc(100% - 30px);
  h5 {
    color: #2b313d;
    font-size: 14px;
    font-weight: 500;
    width: 100%;
    overflow: hidden;
    display: inline-block;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: left;
  }

  p {
    color: ${({ theme }) => theme.colors.text.secondary};
    font-size: 12px;
    font-weight: 400;
    padding: 0;
  }
`;
